export enum SortDirection {
  ASCENDING,
  DESCENDING,
}
